import { useTranslation } from 'react-i18next';
import { classNames } from '@framework/utils';
import { SortOrderMenu } from '../SortOrderMenu';
import type { SortOrder } from '../SortOrderMenu';

type FilterType = 'all' | 'unread' | 'resolved';

type Props = {
  filterType: FilterType;
  onFilterChange: (filter: FilterType) => void;
  sortOrder: SortOrder;
  onSortChange: (order: SortOrder) => void;
};

export type { SortOrder, FilterType };

export const CommentListFilterControls: React.FC<Props> = ({
  filterType,
  onFilterChange,
  sortOrder,
  onSortChange,
}: Props) => {
  const { t } = useTranslation();

  const filterButtons: { value: FilterType; label: string }[] = [
    { value: 'all', label: t('viewModel.commentList.filterAll') },
    { value: 'unread', label: t('viewModel.commentList.filterUnread') },
    { value: 'resolved', label: t('viewModel.commentList.filterResolved') },
  ];

  return (
    <div className="px-3 pb-2">
      <div className="flex gap-1">
        {filterButtons.map((btn) => (
          <button
            key={btn.value}
            type="button"
            aria-pressed={filterType === btn.value}
            className={classNames(
              'rounded-md px-3 py-1 text-xs font-bold',
              filterType === btn.value ? 'bg-brand text-white' : 'text-black hover:bg-gray-100'
            )}
            onClick={() => onFilterChange(btn.value)}
          >
            {btn.label}
          </button>
        ))}
      </div>
      <div className="mt-2">
        <SortOrderMenu
          menuId="comment-list-sort-menu"
          sortOrder={sortOrder}
          labels={{ newest: t('viewModel.commentList.sortNewest'), oldest: t('viewModel.commentList.sortOldest') }}
          onSortChange={onSortChange}
        />
      </div>
    </div>
  );
};
